// 接口文档：https://console-docs.apipost.cn/preview/9d5405b83e1477a2/c0ce8ee710614ba9?target_id=b6199940-74a3-4215-9fa3-137ec73d8403
import { PromiseResponseProps } from "@/config/types/common";
import { MessageCategory } from "@/config/types/message";
import { LikeType, TrendCommentItem, TrendItem } from "@/config/types/trend";
import { _cookie } from "@/utils/constant";
import { requestApp, requestCommunity } from "@/utils/request";
import Cookies from "js-cookie";

/**
 * 这是请求APP端使用的接口，需要传一些公共参数
 */
export const commonData = {
  token: Cookies.get(_cookie.TOKEN) || "",
  channel: "h5",
  is_first: 0,
  language: "zh",
  os: "h5",
  screen: `${screen.width}*${screen.height}`,
  time: (new Date().getTime() / 1000).toFixed(0),
  type: "h5",
  user_agent: navigator.userAgent,
  user_id: "",
  version: "5.0.0",
  action: 0,
  refresh_token: null,
  expires_in: 0,
  token_start_time: 0,
};

/**
 * 获取企业以机构号发布的动态列表
 */
export const getCompanyTrendsList = (data: {
  pageNum: number;
  pageSize: number;
  orgId: string;
}) => {
  return requestApp({
    url: "/api",
    method: "post",
    data: {
      body: data,
      head: {
        ...commonData,
        action: 7028,
      },
    },
  }) as any;
};

// 动态详情
export function getTrendDetail(data: {
  trendsId: string; // 动态 id
  expireMinutes?: number; // oss资源过期时间
}): PromiseResponseProps<TrendItem> {
  return requestApp({
    url: "/api",
    method: "post",
    data: {
      body: data,
      head: {
        ...commonData,
        action: 7005,
      },
    },
  }) as any;
}

// 动态评论列表
export function getTrendCommentList(data: {
  trendsId: string; // 动态 id
  pageNum: number; //当前页数
  pageSize: number; //每页展示数
  asc: boolean; //时间排序 true 正序 false 倒序
}): PromiseResponseProps<{
  list: TrendCommentItem[];
  pages: number; //页数
  size: number; // 每页条数
  total: number; // 总条数
  current: number; // 当前页数
}> {
  return requestApp({
    url: "/api",
    method: "post",
    data: {
      body: data,
      head: {
        ...commonData,
        action: 7015,
      },
    },
  }) as any;
}

// 点赞
export function setTrendLikeBehavior(data: {
  likeType: LikeType;
  likeId: string;
}): PromiseResponseProps<null> {
  return requestApp({
    url: "/api",
    method: "post",
    data: {
      body: data,
      head: {
        ...commonData,
        action: 7009,
      },
    },
  }) as any;
}

// 发送评论
export function setTrendReply(data: {
  content: string; // 内容
  trendsId: string; // 动态 id
  commentsId: string; // 评论 id
  parentReplyId?: string;
  personalPublic?: "Y" | "N"; // 是否是以个人身份发布，若是N，则认为是机构号发布
}): PromiseResponseProps<null> {
  return requestApp({
    url: "/api",
    method: "post",
    data: {
      body: {
        personalPublic: "Y",
        ...data,
      },
      head: {
        ...commonData,
        action: 7020,
      },
    },
  }) as any;
}

// 查询 app 版本
export function getAppVersion(data: {
  os: "android" | "ios";
}): PromiseResponseProps<{ os: "android" | "ios"; last_version: string }> {
  return requestApp({
    url: "/api",
    method: "post",
    data: {
      body: data,
      head: {
        ...commonData,
        action: 8023,
      },
    },
  }) as any;
}

// 获取动态消息
export const getTrendMessage = (data: {
  page: number;
  page_size: number;
  message_type?: MessageCategory;
}) => {
  return requestCommunity({
    url: "/api/message/v1/list",
    method: "post",
    data,
  }) as any;
};

// 关注/取关
export const followChange = (data: { followUserId: string; followType: string }) => {
  return requestCommunity({
    url: "/api/follow/v1/follow",
    method: "post",
    data,
  }) as any;
};
